import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InstitucionesService {

  constructor(private http: HttpClient) { }

  getInstituciones(): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getInstituciones/");
  }
}
